/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AttributeDetails {
    getFixupPrototypeFunction() { return AttributeDetails.fixupPrototype; }

    static newInstance(model: Partial<AttributeDetails>): AttributeDetails {
        let obj = Object.assign(new AttributeDetails(), model);
        AttributeDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AttributeDetails>): AttributeDetails {
        if (!model) return null;
        return AttributeDetails.newInstance(<AttributeDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AttributeDetails) {
        if (!obj) return;

        models.AttributeDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AttributeDetails): boolean {
        Object.setPrototypeOf(obj, AttributeDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.service_accounts) {
            for (let val of this.service_accounts) {
                models.CloudAccountDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Service account id is unique can be obtained from the list cloud
     */
    service_accounts: Array<models.CloudAccountDetails>;

}
